import ArticleListCarousel from './article-list-carousel';

const articleListCarouselConfig = {
  name: 'articleListCarousel',
  class: ArticleListCarousel,
  querySelector: {
    articleContent: '.article-list__content',
    enlargedThumb: '.article-list-carousel__article-thumb-enlarged img',
  },
  querySelectorAll: {
    articles: '.article-list__article',
    articleTitles: '.article-list__article-title',
  },
  options: {
    unslickClass: 'article-list-carousel--unslick',
    stackedClass: 'article-list__article--is-stacked',
    slatClass: 'article-list__article--is-slat',
    slickOptions: {
      mobileFirst: true,
      adaptiveHeight: true,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      swipeToSlide: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
          },
        },
      ],
    },
    slickOptionsSidebar: {
      autoplaySpeed: 0,
      mobileFirst: true,
      autoplay: false,
      adaptiveHeight: true,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      variableWidth: true,
    },
    slickOptionsImageGallery: {
      mobileFirst: true,
      adaptiveHeight: true,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  },
};

export default articleListCarouselConfig;
